(() => {
  const cardSelector = 'xo-product[data-kik-availability-card]';
  const badgeSelector = '.xo-badge-sold-out';
  const attempted = new WeakSet();
  const retryable = new WeakSet();
  let scanQueued = false;

  const productUrl = (card) => {
    try {
      const url = new URL(card.dataset.productUrl, window.location.origin);
      if (url.origin !== window.location.origin) return null;
      url.search = '';
      url.hash = '';
      url.pathname = `${url.pathname.replace(/\/$/, '')}.js`;
      return url.href;
    } catch {
      return null;
    }
  };

  const isAvailable = (product) => {
    if (!product || !Array.isArray(product.variants)) return false;
    return product.available === true || product.variants.some((variant) => variant.available === true);
  };

  const checkCard = async (card, retry = false) => {
    if (retry ? !retryable.has(card) : attempted.has(card)) return;
    attempted.add(card);
    if (!card.querySelector(badgeSelector)) return;

    const url = productUrl(card);
    if (!url) return;

    const controller = new AbortController();
    const timeout = window.setTimeout(() => controller.abort(), 8000);

    try {
      const response = await fetch(url, {
        cache: 'no-store',
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
        signal: controller.signal,
      });
      if (!response.ok) {
        retryable.add(card);
        return;
      }

      retryable.delete(card);
      const product = await response.json();
      if (String(product.id) !== card.dataset.productId || !isAvailable(product)) return;
      card.querySelectorAll(badgeSelector).forEach((badge) => badge.remove());
    } catch {
      retryable.add(card);
    } finally {
      window.clearTimeout(timeout);
    }
  };

  const scan = (retry = false) => {
    document.querySelectorAll(cardSelector).forEach((card) => checkCard(card, retry));
  };

  const queueScan = () => {
    if (scanQueued) return;
    scanQueued = true;
    queueMicrotask(() => {
      scanQueued = false;
      scan();
    });
  };

  const start = () => {
    scan();
    new MutationObserver(queueScan).observe(document.documentElement, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', queueScan);
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) scan(true);
  });
})();
